<template>
  <!-- 试卷详情 -->
  <div class="answer-manage">
    <div class="question-item" v-if="$route.query.type==3">
      <div class="item-title">
        <p class="ques-stem">
          <font class="ques-type">{{getQuesType(detail.ques_type)}} 
            <!-- <span  v-if="type!=5">{{detail.score}}分</span> -->
          </font>
          <span v-html="detail.ques_stem_text"></span>
        </p>
        <!-- <p class="ques-anwer" v-if="type==2 || type==5">
          <span>|</span>
          <font>选项：{{question.user_answer}}</font>
          <span
            class="user-flag"
            :class="{'hover-color':question.is_right==1}"
          >{{question.is_right==1 ? "正确":'错误'}}</span>
        </p> -->
      </div>
      <div v-if="detail.ques_type==4" class="line-question">
        <div class="left-part">
          <div v-for="(optionL, idxL) in detail.ques_option.left" :key="idxL">
            <span>{{idxL+1}})</span>、
            <div class="ques-stem" v-html="optionL.content"></div>
          </div>
        </div>
        <div class="right-part">
          <div v-for="(optionR, idxR) in detail.ques_option.right" :key="idxR">
            <span>{{sort[idxR]}})</span>、
            <div class="ques-stem" v-html="optionR.content"></div>
          </div>
        </div>
      </div>
      <div v-else-if="detail.ques_type==5" class="subject-question">
        <!-- <div v-html="detail.right_answer"></div> -->
      </div>
      <ul v-else class="options" v-for="(option, i) in detail.ques_option" :key="i">
        <li>
          <font>{{sort[i]}}、</font>
          <span class="ques-stem" v-html="option.content"></span>
        </li>
      </ul>
      <p class="answer" @click="open">
        <Icon type="ios-search" />展开答案解析
      </p>
      <div class="answer-info" v-show="open_anwser">
        <p v-if="detail.ques_type!=5">
          正确答案
          <font>{{detail.right_answer}}</font>
          <font>考点： {{detail.point_name ? detail.point_name:'暂无考点'}}</font>
        </p>
        <div>
          题目解析：
          <span v-if="detail.ques_analysis" class="ques-stem" v-html="detail.ques_analysis"></span>
          <span v-else class="ques-stem">暂无解析</span>
        </div>
      </div>
    </div>
    <Row class="ask-info">
      <Row type="flex" class="ask-user-info">
        <Col style="width: 60px;">
          <img :src="detail.avatar" style="width:50px" />
        </Col>
        <Col :xs="11">
          <div class="user-name">{{ detail.nickname }}</div>
          <div class="ask-time ">{{ detail.created_at }}</div>
        </Col>
      </Row>
      <Row class="ask-content">
        <Col :xs="10">
          <p class="ask-title" v-if="$route.query.type!=3">{{ detail.title }}</p>
          </Col>
          <Col align="right">
            赞 {{ detail.like_number }}
          </Col>
      </Row>
      <Row class="ask-content">
        <p>{{ detail.content }}</p>
      </Row>
      <Row class="ask-images">
        <div v-if="detail.images">
          <img v-for="(item,index) in splitImages(detail.images)" :key="index" :src="item" style="width:90px;height:60px;margin-right:20px;"/>
        </div>
      </Row>
      <Row class="ask-action">
            <Button v-if="detail.is_top" type="text" size="small" @click="topAsk">取消置顶-</Button>
            <Button v-else type="text" size="small" @click="topAsk">置顶-</Button>

            <Button v-if="detail.is_hot" type="text" size="small" @click="hotAsk">取消热门-</Button>
            <Button v-else type="text" size="small" @click="hotAsk">热门-</Button>

            <Button type="text" size="small" @click="deleteAsk(id)">删除</Button>
        </Row>
    </Row>

    <div class="title">全部回答</div>
    <!-- 回答列表 -->
    <answer ref="comment" data-url="/api/ask/ask/detailList" :search="{id, type}"></answer>
  </div>
</template>

<script>

import answer from "../../components/Answer";
import { QuestionType } from "@/utils/enums";
export default {
  name: "AnswerManage",
  components: {
    answer
  },
  data() {
    return {
      id: this.$route.query.id,
      type: this.$route.query.type || 1, //1问答板块 2课程问答 3题目问答
      answers: {},
      detail: {},
      sort: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
      open_anwser: 0
    };
  },
  mounted(){
    if (this.$route.query.type == 3) {
      this.mathJax()
    }
  },
  methods: {
    // other
    async getAskInfo() {
      this.$http.get('/api/ask/ask/detail',{ id: this.id, type: this.type }).then(res => {
        this.detail = res;
      });
    },

    topAsk() {
      this.$http.put("/api/ask/changeTopHot",{id: this.id, type: 1}).then(res => {
        this.detail.is_top = !this.detail.is_top;
      });
    },

    hotAsk() {
      this.$http.put("/api/ask/changeTopHot",{id: this.id, type: 2 }).then(res => {
        this.detail.is_hot = !this.detail.is_hot;
      });
    },

    deleteAsk(id) {
      this.$promiseConfirm("确定要删除该问题吗？").then(res=>{
        if(res){
          this.$http.delete("/api/ask/delAsk",{id});
          this.$router.push({ name: "AskManage" });
        }
      });
    },
    splitImages(images){
      return images.split(',');
    },
    getQuesType(type) {
      return QuestionType.getValue(type);
    },
    open() {
      this.open_anwser = !this.open_anwser;
    },
    mathJax() {
      let _this = this;
      if (this.MathJax.isMathjaxConfig) { // 判断是否初始配置，若无则配置。
          this.MathJax.initMathjaxConfig()
      }
      setTimeout(function(){
        _this.MathJax.MathQueue()// 传入组件id，让组件被MathJax渲染
      },1000)
    },
  },
  created() {
    this.getAskInfo();
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/common.scss";
pre {
  margin: 10px 0;
}
.title{
  margin-top: 20px;
  margin-bottom: 0;
}
.ask-title{
  font-weight: bold;
  line-height: 40px;
}
.hover-color {
  color: #2d8cf0 !important;
  border-color: #2d8cf0 !important;
}
.question-item {
  padding-bottom: 10px;
  .item-title {
    line-height: 26px;
    font {
      color: #777;
      padding-right: 4px;
    }
    .ques-type {
      color: #2d8cf0 !important;
      // padding-left: 20px;
    }
    span {
      padding: 0 10px;
    }
    .user-flag {
      display: inline-block;
      padding: 0 2px;
      margin-left: 10px;
      border: 1px solid #ed4014;
      color: #ed4014;
      height: 17px;
      font-size: 12px;
      line-height: 17px;
    }
    .ques-anwer {
      display: inline;
    }
  }
  line-height: 34px;
  .options {
    padding-left: 14px;
    font {
      display: inline-block;
    }
  }
  .line-question {
    padding-top: 4px;
    display: flex;
    width: 700px;
    padding-left: 14px;
    justify-content: space-between;
    .left-part,
    .right-part {
      width: 42%;
      line-height: 26px;
    }
  }
  .answer {
    padding-left: 14px;
    color: #ed4014;
    cursor: pointer;
  }
  .answer-info {
    padding: 10px 20px 20px;
    margin-left: 14px;
    background: #f1f1f1;
    border-radius: 5px;
    p {
      font {
        &:nth-child(1) {
          color: #2d8cf0;
          padding-right: 30px;
        }
        &:nth-child(2) {
          color: #333;
        }
      }
      &:nth-child(2) {
        line-height: 20px;
      }
    }
  }
  .ques-stem {
    /deep/ img {
      max-width: 200px;
    }
  }
}
</style>
